import 'air-datepicker/air-datepicker.css'

import { Controller } from '@hotwired/stimulus'
import AirDatepicker, { type AirDatepickerViews } from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en'

// Connects to data-controller="datepicker"
export default class extends Controller {
  static targets = [
    'input',
  ]

  declare readonly inputTarget: HTMLInputElement

  static values = {
    minDate: String,
    maxDate: String,
    dateFormat: String,
    view: String,
    position: String,
    clearButton: Boolean,
  }

  declare minDateValue: string
  declare maxDateValue: string
  declare dateFormatValue: string
  declare viewValue: AirDatepickerViews
  declare positionValue: string
  declare clearButtonValue: boolean
  declare hasClearButtonValue: boolean

  connect () {
    const dateFormat = this.dateFormatValue === '' ? 'MMMM d, yyyy' : this.dateFormatValue
    const viewDisplay = this.viewValue || 'months'
    const position = this.positionValue === '' ? 'top center' : this.positionValue

    // Default to no clear button to preserve existing behavior unless explicitly enabled
    const clearable = this.hasClearButtonValue ? this.clearButtonValue : false

    // eslint-disable-next-line no-new
    new AirDatepicker(this.inputTarget, {
      locale: localeEn,
      view: viewDisplay,
      minView: viewDisplay,
      dateFormat,
      autoClose: true,
      minDate: this.minDateValue,
      maxDate: this.maxDateValue,
      // Show a clear button in the calendar popover to allow emptying the field
      buttons: clearable ? ['clear'] : [],
      // @ts-expect-error: This does work as expected.
      position,
    })
  }
}
